import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout, setCredentials } from "../features/auth/authSlice";
import { toast } from "react-hot-toast";
import { getOrCreateSessionId } from "../util/session";

const baseQuery = fetchBaseQuery({
  //baseUrl: "http://localhost:3500/api",
  baseUrl: "/api",
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    // Set Content-Type for all requests
    headers.set("Content-Type", "application/json");//

    const token = getState().auth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    } else {
      const sessionId = getState().auth.token ? null : getOrCreateSessionId();
      if (sessionId) headers.set("x-session-id", sessionId);
    }
    return headers;
  },
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  const status = result?.error?.status;
  const isAuthRequired = args?.meta?.requiresAuth;

  if (status === 500) {
    toast.error("Server error. Please try again later.");
  } else if (status === 403) {
    toast.error("Access forbidden. Please check your credentials.");
  }

  if (status === 401 && isAuthRequired) {
    toast.error("Access token expired. Attempting refresh...");

    const refreshResult = await baseQuery("/auth/refresh", api, extraOptions);

    if (refreshResult?.data) {
      api.dispatch(
        setCredentials({ accessToken: refreshResult.data.accessToken })
      );
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logout());
    }
  }

  return result;
};
